var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticStyle: { padding: "30px" } }, [
      _c("div", { staticStyle: { "margin-bottom": "30px" } }, [
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "24px",
              "font-family": "PingFang SC",
              "font-weight": "bold",
              color: "#333333"
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("i18n_tracking_terms_selction")) +
                "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { width: "80%" } },
        [
          _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "18px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434"
                }
              },
              [_vm._v(_vm._s(_vm.$t("i18n_full_container_load")))]
            )
          ]),
          _vm._v(" "),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                staticClass: "card1",
                style: { height: _vm.acIndex == 1 ? "100%" : "" },
                on: {
                  click: function($event) {
                    return _vm.change(1)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "card" },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "20%", height: "40px" } },
                      [
                        _c("el-checkbox", {
                          staticStyle: { zoom: "130%" },
                          on: {
                            change: function($event) {
                              return _vm.switchAllChange($event, "S")
                            }
                          },
                          model: {
                            value: _vm.sValue,
                            callback: function($$v) {
                              _vm.sValue = $$v
                            },
                            expression: "sValue"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              "font-family": "PingFang SC",
                              "font-weight": "500",
                              color: "#343434"
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("i18n_All")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(this.listOcean, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: { width: "20%", height: "40px" }
                        },
                        [
                          _c("el-checkbox", {
                            staticStyle: { zoom: "130%" },
                            on: {
                              change: function($event) {
                                return _vm.selectChange(
                                  item.ispush,
                                  item.id,
                                  index,
                                  "S"
                                )
                              }
                            },
                            model: {
                              value: item.ispush,
                              callback: function($$v) {
                                _vm.$set(item, "ispush", $$v)
                              },
                              expression: "item.ispush"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                "font-family": "PingFang SC",
                                "font-weight": "500",
                                color: "#343434"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.statusc) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "20px",
                      display: "flex",
                      cursor: "pointer"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#999",
                          width: "35px",
                          "font-size": "13px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_More")))]
                    ),
                    _c("i", {
                      staticClass: "el-icon-arrow-down",
                      staticStyle: { display: "inline-block" }
                    })
                  ]
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { width: "80%", "margin-top": "30px" } }, [
        _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "18px",
                "font-family": "PingFang SC",
                "font-weight": "500",
                color: "#343434"
              }
            },
            [_vm._v(_vm._s(_vm.$t("i18n_International_Air_Freight")))]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card1",
            style: { height: _vm.acIndex == 2 ? "100%" : "" },
            on: {
              click: function($event) {
                return _vm.change(2)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "card" },
              [
                _c(
                  "div",
                  { staticStyle: { width: "20%", height: "40px" } },
                  [
                    _c("el-checkbox", {
                      staticStyle: { zoom: "130%" },
                      on: {
                        change: function($event) {
                          return _vm.switchAllChange($event, "A")
                        }
                      },
                      model: {
                        value: _vm.aValue,
                        callback: function($$v) {
                          _vm.aValue = $$v
                        },
                        expression: "aValue"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-family": "PingFang SC",
                          "font-weight": "500",
                          color: "#343434"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("i18n_All")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(this.listAir, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: { width: "20%", height: "40px" }
                    },
                    [
                      _c("el-checkbox", {
                        staticStyle: { zoom: "130%" },
                        on: {
                          change: function($event) {
                            return _vm.selectChange(
                              item.ispush,
                              item.id,
                              index,
                              "A"
                            )
                          }
                        },
                        model: {
                          value: item.ispush,
                          callback: function($$v) {
                            _vm.$set(item, "ispush", $$v)
                          },
                          expression: "item.ispush"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            "font-family": "PingFang SC",
                            "font-weight": "500",
                            color: "#343434"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.statusc) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "20px",
                  display: "flex",
                  cursor: "pointer"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#999",
                      width: "35px",
                      "font-size": "13px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_More")))]
                ),
                _c("i", {
                  staticClass: "el-icon-arrow-down",
                  staticStyle: { display: "inline-block" }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { width: "80%", "margin-top": "30px" } }, [
        _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "18px",
                "font-family": "PingFang SC",
                "font-weight": "500",
                color: "#343434"
              }
            },
            [_vm._v(_vm._s(_vm.$t("i18n_Marine_bulk_cargo")))]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card1",
            style: { height: _vm.acIndex == 3 ? "100%" : "" },
            on: {
              click: function($event) {
                return _vm.change(3)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "card" },
              [
                _c(
                  "div",
                  { staticStyle: { width: "20%", height: "40px" } },
                  [
                    _c("el-checkbox", {
                      staticStyle: { zoom: "130%" },
                      on: {
                        change: function($event) {
                          return _vm.switchAllChange($event, "L")
                        }
                      },
                      model: {
                        value: _vm.lValue,
                        callback: function($$v) {
                          _vm.lValue = $$v
                        },
                        expression: "lValue"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-family": "PingFang SC",
                          "font-weight": "500",
                          color: "#343434"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("i18n_All")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(this.listPacket, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: { width: "20%", height: "40px" }
                    },
                    [
                      _c("el-checkbox", {
                        staticStyle: { zoom: "130%" },
                        on: {
                          change: function($event) {
                            return _vm.selectChange(
                              item.ispush,
                              item.id,
                              index,
                              "L"
                            )
                          }
                        },
                        model: {
                          value: item.ispush,
                          callback: function($$v) {
                            _vm.$set(item, "ispush", $$v)
                          },
                          expression: "item.ispush"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            "font-family": "PingFang SC",
                            "font-weight": "500",
                            color: "#343434"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.statusc) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "20px",
                  display: "flex",
                  cursor: "pointer"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#999",
                      width: "35px",
                      "font-size": "13px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_More")))]
                ),
                _c("i", {
                  staticClass: "el-icon-arrow-down",
                  staticStyle: { display: "inline-block" }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { width: "80%", "margin-top": "30px" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card1",
            style: { height: _vm.acIndex == 4 ? "100%" : "" },
            on: {
              click: function($event) {
                return _vm.change(4)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "card" },
              [
                _c(
                  "div",
                  { staticStyle: { width: "20%", height: "40px" } },
                  [
                    _c("el-checkbox", {
                      staticStyle: { zoom: "130%" },
                      on: {
                        change: function($event) {
                          return _vm.switchAllChange($event, "F")
                        }
                      },
                      model: {
                        value: _vm.fValue,
                        callback: function($$v) {
                          _vm.fValue = $$v
                        },
                        expression: "fValue"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-family": "PingFang SC",
                          "font-weight": "500",
                          color: "#343434"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("i18n_All")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(this.listFba, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: { width: "20%", height: "40px" }
                    },
                    [
                      _c("el-checkbox", {
                        staticStyle: { zoom: "130%" },
                        on: {
                          change: function($event) {
                            return _vm.selectChange(
                              item.ispush,
                              item.id,
                              index,
                              "F"
                            )
                          }
                        },
                        model: {
                          value: item.ispush,
                          callback: function($$v) {
                            _vm.$set(item, "ispush", $$v)
                          },
                          expression: "item.ispush"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            "font-family": "PingFang SC",
                            "font-weight": "500",
                            color: "#343434"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.statusc) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "20px",
                  display: "flex",
                  cursor: "pointer"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#999",
                      width: "35px",
                      "font-size": "13px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_More")))]
                ),
                _c("i", {
                  staticClass: "el-icon-arrow-down",
                  staticStyle: { display: "inline-block" }
                })
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "18px",
            "font-family": "PingFang SC",
            "font-weight": "500",
            color: "#343434"
          }
        },
        [_vm._v("FBA")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ab0db5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ab0db5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/personalInfo/TrackSetting.vue
// module id = null
// module chunks = 